import React from 'react'

/** A View indicating a HTTP 404. */
const NotFound = () => {
  return (
    <div>Route not found</div>
  )
}

export default NotFound



// WEBPACK FOOTER //
// ./src/components/common/NotFound.js